import { XMLHttpRequestHandler } from "../XMLHttpRequestHandler/XMLHttpRequestHandler";
import { vnAppZone } from "./vn_app_zone";
export class vnModule {
    constructor(vnAppZone) {
        this._isLeavePageWarningNeeded = false;
        this.name = this.getModuleName();
        this.vnAppZone = vnAppZone;
    }
    get name() {
        return this._name;
    }
    set name(name) {
        this._name = name;
    }
    get content() {
        return this._content;
    }
    set content(content) {
        this._content = content;
    }
    get isLeavePageWarningNeeded() {
        return this._isLeavePageWarningNeeded;
    }
    set isLeavePageWarningNeeded(isLeavePageWarningNeeded) {
        this._isLeavePageWarningNeeded = isLeavePageWarningNeeded;
    }
    get loggedUser() {
        return this._loggedUser;
    }
    set loggedUser(loggedUser) {
        this._loggedUser = loggedUser;
    }
    get loggedUserAccessType() {
        return this._loggedUserAccessType;
    }
    set loggedUserAccessType(loggedUserAccessType) {
        this._loggedUserAccessType = loggedUserAccessType;
    }
    setVnAppZone(vnAppZone) {
        this.vnAppZone = vnAppZone;
    }
    getVnAppZone() {
        return this.vnAppZone;
    }
    cancelForm() {
    }
    cleanup() {
    }
    /**
     * Execute the loading process of a page.
     * If the the user needs to be logged in, execute the loggin check, and,
     * in the case where the user is NOT logged in and reqired to be,
     * load the login page.
     *
     */
    load(container) {
        this.internalLoad(container);
    }
    /**
     * this function loads the page without any loggin check.
     * This function is to be used ONLY in this class. (private)
     *
     */
    internalLoad(container) {
        this.build();
        this.insertIn(container);
        this.fillPage();
    }
    build() {
        this.content = [];
        for (let c of this.buildContent()) {
            this.content.push(c);
        }
        return this.content;
    }
    insertIn(container) {
        container.innerHTML = "";
        for (let c of this.content) {
            container.appendChild(c);
        }
    }
    fillPage() {
        // default no action
    }
    loadingIn(e) {
        e.classList.add("loading");
    }
    loadingOut(e) {
        e.classList.remove("loading");
    }
    getUser() {
        return this.vnAppZone.getApp().loggedUser;
    }
    //
    // This function let you set a function to handle each of
    // the different http code returned by a request.
    getRequestReturnFunction(httpCodeFunction, elseAction) {
        return function (req, obj) {
            return function () {
                if (req.request.readyState == 4) {
                    let responseParsed = JSON.parse(req.request.response);
                    for (let codeReturn of httpCodeFunction) {
                        if (req.request.status == codeReturn.code) {
                            codeReturn.function(responseParsed, obj);
                            return;
                        }
                    }
                    elseAction(responseParsed, obj);
                }
            };
        };
    }
}
